import { Platform } from 'react-native';

// Platform-specific screen resolution
// Metro bundler will resolve .web.jsx files automatically when Platform.OS === 'web'
// This index file provides explicit exports for clarity and tree-shaking

// HomeScreen - uses Home.web.jsx on web, Home.js on native
export const HomeScreen = Platform.select({
  web: () => require('./Home.web.jsx').default,
  default: () => require('./Home').default,
})();

// InboxScreen - uses Inbox.web.jsx on web (when created), Inbox.js on native
export const InboxScreen = Platform.select({
  web: () => {
    try {
      return require('./Inbox.web.jsx').default;
    } catch (e) {
      return require('./Inbox').default;
    }
  },
  default: () => require('./Inbox').default,
})();

// ProfileFacilitiesScreen - web-exclusive screen for facility profile
// Uses ProfileFacilities.web.jsx on web, falls back to Settings/Profile on native
export const ProfileFacilitiesScreen = Platform.select({
  web: () => require('./ProfileFacilities.web.jsx').default,
  default: () => require('./Settings/Profile').default,
})();

// ProfileDoctorScreen - web-exclusive screen for doctor profile
// Uses ProfileDoctors.web.jsx on web, falls back to Settings/Profile on native
export const ProfileDoctorScreen = Platform.select({
  web: () => require('./ProfileDoctors.web.jsx').default,
  default: () => require('./Settings/Profile').default,
})();

// Re-export other screens for convenience
export { default as DetailsScreen } from './Details';
export { default as CheckinScreen } from './Checkin';
export { default as OnboardScreen } from './Onboarding';
export { default as TransactionScreen } from './Transaction';
export { default as JobDescriptionScreen } from './JobDescription';
